<template>
  <div class="foodsRank">
    <img src="@/assets/images/list/food.png" class="bgp" />

    <!-- 标题 -->
    <h3>
      {{ cityName }}{{ areaName
      }}{{ activeTagName === 'other' ? '' : activeTagName }}美食人气榜
    </h3>
    <!-- 城市 -->
    <!-- <div class="citybox">
      <img src="@/assets/images/list/area.png" class="img" />
      <div class="text">
        {{ `${cityName}${areaName ? ` - ${areaName}` : ''}` }}
      </div>
    </div> -->
    <!-- 标签描述 -->
    <div class="tagdes" v-if="tagDes">
      {{ tagDes }}
    </div>
    <!-- item -->
    <div v-if="list.length > 0">
      <div class="listbox" v-if="list.length > 0">
        <ul v-for="(item, index) in list" :key="item.id">
          <!-- ------------------------------------------- -->
          <div class="item-rank" v-if="index + 1 < 4">
            <div class="pic">
              <img :src="item.indexUrl" />
            </div>
            <div class="infobox">
              <van-image
                :src="
                  index === 0
                    ? require('@/assets/images/list/a.png')
                    : index === 1
                    ? require('@/assets/images/list/b.png')
                    : require('@/assets/images/list/c.png')
                "
                class="rankimg"
              />

              <div class="infotext">
                <div class="name">
                  {{ item.title }}
                </div>
                <div class="recommend">
                  <Recommend
                    :recommendCount="item.recommendCount"
                    :unRecommendCount="item.unRecommendCount"
                  ></Recommend>
                </div>
                <div class="tag" v-if="item.tagsStr">
                  <div
                    class="tags"
                    v-for="el in item.tagsStr.split('，').slice(0, 2)"
                    :key="el"
                  >
                    <div class="tagBox">
                      <div class="text">
                        {{ el.length > 6 ? `${el.slice(0, 5)}...` : el }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ------------------------------------------- -->
          <div class="item-other" v-else>
            <div class="indexbgp">{{ index + 1 }}.</div>
            <div class="pic">
              <img :src="item.indexUrl" />
            </div>
            <div class="infobox">
              <div class="name">{{ item.title }}</div>
              <div class="recommend">
                <Recommend
                  :recommendCount="item.recommendCount"
                  :unRecommendCount="item.unRecommendCount"
                ></Recommend>
              </div>
              <div class="tag" v-if="item.tagsStr">
                <div
                  class="tags"
                  v-for="el in item.tagsStr.split('，').slice(0, 3)"
                  :key="el"
                >
                  <div class="tagBox">
                    <div class="text">
                      {{ el.length > 6 ? `${el.slice(0, 5)}...` : el }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>

      <div class="more">
        <span>进入APP查看更多榜单~</span>
      </div>
    </div>
    <div v-else class="emptybox">
      <img src="@/assets/images/empty.png" alt="" class="empty" />
      <div class="text">该榜单暂无数据，打开APP查看更多~</div>
    </div>
    <open-app />
  </div>
</template>

<script>
import { getHotFoodPage, getTagTabs } from '@/service/api'
import CommentList from '@/components/CommentList.vue'
import OpenApp from '@/components/OpenApp.vue'
import { getUrlParams } from '@/utils'
import Recommend from '@/components/Recommend'
export default {
  components: { CommentList, OpenApp, Recommend },
  data() {
    return {
      list: [],
      title: '',
      description: '',
      cityName: '',
      areaName: '',
      activeTagName: '',
      tagTabs: [],
      tagDes: '',
    }
  },
  created() {
    this.cityName = decodeURIComponent(getUrlParams('cityName'))
    this.areaName = decodeURIComponent(getUrlParams('areaName'))
    this.activeTagName = decodeURIComponent(getUrlParams('activeTagName'))
    // this.cityName = '西安'
    // this.areaName = ''
    // this.activeTagName = ''
  },
  mounted() {
    if (this.cityName) {
      this._getTagList().then((res) => {
        this._getHotFoodPage()
      })
    }
  },
  methods: {
    async _getTagList() {
      try {
        const city = this.cityName
        const type = 'food'
        const res = await getTagTabs(city, type)
        if (res) {
          this.tagTabs = res
          if (this.activeTagName !== '' || this.activeTagName !== 'other') {
            const desc = res.find((item) => {
              return item.tagName === this.activeTagName
            })
            this.tagDes = desc.tagDesc
            console.log('标签描述----------', this.tagDes)
          }
        }
        return res
      } catch (error) {}
    },
    //获取美食详情
    async _getHotFoodPage() {
      const data = {
        currentPage: 1,
        pageSize: 15,
        city: this.cityName,
        district: this.areaName,
        tagParam: this.activeTagName,
        tagList: this.activeTagName === 'other' ? this.tagTabs : null,
      }
      try {
        const res = await getHotFoodPage(data)
        if (res) {
          this.list = res.list
        }
      } catch (error) {
        this.$toast(`${error}`)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.foodsRank {
  width: 100%;
  padding: 10px;
  background-color: #f5f5f5;
  padding-bottom: 50px;
  background-image: linear-gradient(
    to bottom,
    #fc862c,
    #facd9b 12%,
    #f5f5f5 35%,
    #fff
  );
  .bgp {
    width: 100%;
    position: absolute;
    top: -5px;
    left: 0;
    z-index: 0;
  }
  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    font-size: 18px;
    color: #111;
    font-weight: 700;
    white-space: pre-wrap;
    margin-bottom: 10px;
  }
  .citybox {
    margin-top: 10px;
    width: 100%;
    background-color: #fbf1e7;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    position: relative;
    z-index: 2;
    .text {
      font-size: 14px;
      color: #333;
      font-weight: 700;
      margin-left: 5px;
    }
  }

  .tagdes {
    width: 100%;
    padding: 10px;
    background-color: #f5f5f5;
    z-index: 9;
    position: relative;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    font-size: 13px;
    color: #555;
    word-break: break-all;
    line-height: 17px;
  }

  // list
  .listbox {
    position: relative;
    z-index: 2;
    margin-top: 10px;
    ul {
      // -----------
      .item-rank {
        width: 100%;
        position: relative;
        border-radius: 12px;
        height: 200px;
        background-color: #fff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 10px;
        display: flex;
        align-items: flex-end;
        .pic {
          position: absolute;
          width: 100%;
          height: 180px;
          top: 0;
          left: 0;
          z-index: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          border-radius: 12px;
          img {
            width: 100%;
            height: auto;
            background-size: cover;
          }
        }
        .rankimg {
          width: 48px;
          height: 63px;
          flex-shrink: 0;
        }
        .infobox {
          position: relative;
          z-index: 1;
          width: 100%;
          background-image: linear-gradient(to bottom, #ecdcd6, #fdfcfc);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: start;
          padding: 10px;

          .infotext {
            flex: 1;
            margin-left: 10px;
            font-size: 0;
            .name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 16px;
              font-weight: 700;
              color: #333;
            }
            .recommend {
            }
            .tag {
              width: 100%;
              display: flex;
              margin-top: 5px;
              .tagBox {
                background: rgba(0, 0, 0, 0.04);
                border: 1px solid rgba(0, 0, 0, 0.05);
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 2px 6px;
                margin-right: 4px;
                .text {
                  font-size: 11px;
                  color: rgba(0, 0, 0, 0.65);
                  line-height: 16px;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }

      // -----------
      .item-other {
        display: flex;
        width: 100%;
        background-color: #fdfdfd;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        margin-bottom: 10px;
        padding: 10px;
        position: relative;

        .indexbgp {
          width: 44px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          background-image: url('../assets/images/list/rankbg.png');
          background-size: contain;
          background-repeat: no-repeat;
          font-size: 17px;
          color: #eee;
        }
        .pic {
          width: 90px;
          height: 90px;
          border-radius: 12px;
          overflow: hidden;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .infobox {
          margin-left: 15px;
          flex: 1;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          overflow: hidden;
          padding: 5px 0;
          .name {
            max-width: 220px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            font-weight: 700;
            color: #333;
          }
          .recommend {
          }
          .tag {
            width: 100%;
            display: flex;
            align-items: center;
            margin-top: 5px;
            .tagBox {
              background: rgba(0, 0, 0, 0.04);
              border: 1px solid rgba(0, 0, 0, 0.05);
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 3px 8px;
              max-width: 90px;
              margin-right: 4px;
              .text {
                font-size: 11px;
                color: rgba(0, 0, 0, 0.65);
                line-height: 16px;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: cornflowerblue;
    margin: 20px 0;
  }
  .emptybox {
    width: 100%;
    height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty {
      width: 6rem;
    }
    .text {
      font-size: 14px;
      color: #777;
    }
  }
}
</style>
